import ArrowButton from 'components/Misc/ArrowButton/ArrowButton';

export default function WebformButton({ element, fieldProps }) {
  return <ArrowButton {...fieldProps}>{element['#value']}</ArrowButton>;
}
